var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyDnaPillIcon = function SvgWhyDnaPillIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1738 38.6087C22.9871 43.7954 14.5778 43.7954 9.39117 38.6087C4.20449 33.422 4.20449 25.0128 9.39116 19.8261L19.8259 9.39132C25.0126 4.20464 33.4219 4.20463 38.6086 9.39131C43.7952 14.578 43.7952 22.9872 38.6086 28.1739L28.1738 38.6087Z",
    fill: "white",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 14.6084L19.8258 9.39098C25.0125 4.20431 33.4217 4.20431 38.6084 9.39098C43.7951 14.5777 43.7951 22.9869 38.6084 28.1736L33.391 33.391L14.6084 14.6084Z",
    fill: "#FEECAB",
    stroke: "#DAB154",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
};
export default SvgWhyDnaPillIcon;